import { Navigate, Outlet, Route, Routes } from "react-router-dom"
import { AuthProvider } from "@/contexts/auth-context"
import { ThemeProvider } from "@/components/theme-provider"
import { Toaster } from "@/components/toaster"
import { MotionProvider } from "@/components/motion-provider"
import PreloadPagesWrapper from "@/app/preload-pages-wrapper"
import LoginPage from "@/app/page"
import AdminLayout from "@/app/admin/layout"
import UserLayout from "@/app/user/layout"
import AdminCdkPage from "@/app/admin/cdk/page"
import AdminDashboardPage from "@/app/admin/dashboard/page"
import AdminDevicesPage from "@/app/admin/devices/page"
import AdminLogsPage from "@/app/admin/logs/page"
import AdminOrdersPage from "@/app/admin/orders/page"
import AdminSettingsPage from "@/app/admin/settings/page"
import AdminTasksPage from "@/app/admin/tasks/page"
import AdminUpstreamArkPage from "@/app/admin/upstream-ark/page"
import AdminUsersPage from "@/app/admin/users/page"
import PreviewPage from "@/app/preview/page"
import UserAccountPage from "@/app/user/account/page"
import UserDashboardPage from "@/app/user/dashboard/page"
import UserLogsPage from "@/app/user/logs/page"
import UserSettingsPage from "@/app/user/settings/page"

function AdminRouteLayout() {
  return <AdminLayout><Outlet /></AdminLayout>
}

function UserRouteLayout() {
  return <UserLayout><Outlet /></UserLayout>
}

export function App() {
  return (
    <ThemeProvider defaultTheme="light">
      <AuthProvider>
        <MotionProvider />
        <PreloadPagesWrapper />
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/preview" element={<PreviewPage />} />
          <Route element={<AdminRouteLayout />}>
            <Route path="/admin/cdk" element={<AdminCdkPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/devices" element={<AdminDevicesPage />} />
            <Route path="/admin/logs" element={<AdminLogsPage />} />
            <Route path="/admin/orders" element={<AdminOrdersPage />} />
            <Route path="/admin/settings" element={<AdminSettingsPage />} />
            <Route path="/admin/tasks" element={<AdminTasksPage />} />
            <Route path="/admin/upstream-ark" element={<AdminUpstreamArkPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
          </Route>
          <Route element={<UserRouteLayout />}>
            <Route path="/user/account" element={<UserAccountPage />} />
            <Route path="/user/dashboard" element={<UserDashboardPage />} />
            <Route path="/user/logs" element={<UserLogsPage />} />
            <Route path="/user/settings" element={<UserSettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
        <Toaster />
      </AuthProvider>
    </ThemeProvider>
  )
}
